import React, { useEffect, useState } from "react";
import { object, array, number, string, bool } from "prop-types";

import { Link, WithLazy } from "@quintype/components";
import CardImage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";
import StoryDate from "../../atoms/story-date";
import { getAStory } from "../../helper/api";

import "./story-card25.m.css";
import Slideshow from "../../story-templates/story-elements/slide-show";

const StoryCard25 = ({ story, aspectRatio, imageType, headerType, headerLevel, lineClamp, bigCard, embed }) => {
  const widths = bigCard ? [400, 700] : [400];
  const [linkedStory, setLinkedStory] = useState(null);
  const [slideshowElement, setSlideshowElement] = useState(null);
  useEffect(() => {
    if (story?.id) {
      getAStory(story.id).then((res) => {
        setLinkedStory(res);
        setSlideshowElement(
          res?.cards
            ?.flatMap((card) => card?.["story-elements"] || [])
            ?.find(
              (el) => el?.type === "composite" && el?.metadata?.type === "slideshow" && el?.subtype === "image-gallery"
            ) || null
        );
      });
    }
  }, [story?.id]);

  return (
    <div className="story-card story-card-5" styleName="story-card-25" id="story-card-25">
      {embed !== "" ? (
        <div styleName="embed-wrapper" dangerouslySetInnerHTML={{ __html: embed }} />
      ) : (
        <Link href={`/${story.slug}`}>
          <CardImage
            story={story}
            showVideoIcon
            aspectRatio={aspectRatio}
            imageType={imageType}
            widths={widths}
            sizes="(max-width: 1024px) 20vw, 100vw"
          />
        </Link>
      )}
      <Link href={`/${story.slug}`} className="headline-link">
        <Headline
          text={story.headline}
          headerType={headerType}
          headerLevel={headerLevel}
          story={story}
          lineClamp={lineClamp}
        />
      </Link>
      <Link href={`/${story.slug}`}>
        <span styleName="summary" className="summary line-clamp-2">
          {story?.subheadline
            ? story.subheadline
            : story?.seo?.["meta-description"]
            ? story.seo["meta-description"]
            : null}
        </span>
      </Link>
      {(linkedStory?.["story-template"] == "live-blog") && linkedStory?.cards &&
        linkedStory.cards
          .sort((a, b) => b["card-event-at"] - a["card-event-at"])
          .flatMap((card) =>
            (card["story-elements"] || []).map((el) => ({
              ...el,
              cardEventAt: card["card-event-at"]
            }))
          )
          .filter((el) => el.type === "title" && el.text)
          .slice(0, 2)
          .map((item, idx) => {
            const time = new Date(item.cardEventAt).toLocaleTimeString("en-US", {
              hour: "numeric",
              minute: "2-digit",
              hour12: true
            });


            return (
              <Link href={`/${story.slug}#${idx}`} key={idx} styleName="live-items line-clamp">
                <span styleName="live-time">{time}</span>
                <span styleName="live-item">{item.text}</span>
              </Link>
            );
          })}
    </div>
  );
};

StoryCard25.defaultProps = {
  aspectRatio: [16, 9],
  imageType: "image16x9",
  headerType: 3,
  headerLevel: 3,
  lineClamp: 3,
  bigCard: false,
  embed: ""
};

StoryCard25.propTypes = {
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  headerType: number,
  headerLevel: number,
  lineClamp: number,
  bigCard: bool,
  embed: string
};

export default StoryCard25;
